import type { AdminV2LiveAlert } from "@/types/adminV2";

const UUID_TEXT_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;

const hasFormsRecordIdentity = (alert: AdminV2LiveAlert): boolean =>
  typeof alert.safeMetadata.formId === "string" &&
  UUID_TEXT_PATTERN.test(alert.safeMetadata.formId) &&
  typeof alert.safeMetadata.formSubmissionId === "string" &&
  UUID_TEXT_PATTERN.test(alert.safeMetadata.formSubmissionId);

export const isFormsSubmissionReviewAlert = (
  alert: AdminV2LiveAlert,
): boolean =>
  alert.source === "manual_alert" &&
  alert.eventType === "forms.submission.review_required" &&
  alert.safeMetadata.sourceSystem === "forms" &&
  alert.safeMetadata.reviewReason === "form_submission_review_required" &&
  hasFormsRecordIdentity(alert) &&
  typeof alert.safeMetadata.ownerRuntimeActionId === "string" &&
  UUID_TEXT_PATTERN.test(alert.safeMetadata.ownerRuntimeActionId);

export const isFormsGlobalContactReviewAlert = (
  alert: AdminV2LiveAlert,
): boolean =>
  alert.source === "manual_alert" &&
  alert.eventType === "forms.global_contact.review_required" &&
  alert.safeMetadata.sourceSystem === "forms" &&
  alert.safeMetadata.reviewReason ===
    "global_fhc_contact_match_requires_review" &&
  hasFormsRecordIdentity(alert);

export const isFormsReviewAlert = (alert: AdminV2LiveAlert): boolean =>
  isFormsSubmissionReviewAlert(alert) || isFormsGlobalContactReviewAlert(alert);
